import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import Rapid7InsightVMConfigListing from './Rapid7InsightVMConfigListing'
import Rapid7InsightVMCredentialsForm from './Rapid7InsightVMCredentialsForm'

export default function Rapid7InsightVMPullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={Rapid7InsightVMCredentialsForm}
            PullConfigListingView={Rapid7InsightVMConfigListing}
        />
    )
}